import { Controller } from "@hotwired/stimulus";

// Applies a filter form as soon as one of its choices changes, so there is no separate
// "Filter" button to press. Inputs that need their own timing wire up their own submit:
// see query_filter_controller (debounced while typing) and daterange_controller (only
// once a range is complete).
export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }
}
